module.exports = __webpack_public_path__ + "static/img/computer.60dc104.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/computer.jpg
// module id = hcOX
// module chunks = 1